import { render, staticRenderFns } from "./CustomIndexingLookups.vue?vue&type=template&id=1986ccc7&"
import script from "./CustomIndexingLookups.vue?vue&type=script&lang=ts&"
export * from "./CustomIndexingLookups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports